(function(window, document) {

	/* ----------------------------------- [START] Set Root Screen Width */
	// 為了 320 - 480 手機板的 Point 不重疊，CSS 設置 transform scale 的方式進行
	let oldWidth = 0;
	function getScreenWidth() {
		// 不能有單位，CSS calc不然會失效
		document.documentElement.style.setProperty('--screen-width', window.innerWidth);
	}

	window.addEventListener('load', getScreenWidth);
	window.addEventListener('resize', function() {
		if (oldWidth !== window.innerWidth) {
			oldWidth = window.innerWidth;
			getScreenWidth();
		}
	})
	/* ----------------------------------- [END] Set Root Screen Width */
	/* ----------------------------------- [START] Trigger Nav */

	var dropdown = $('#location-select__list');
	dropdown.find('a').on('click', function() {
		dropdown.foundation('close');


		setTimeout(() => {
			document.documentElement.classList.remove('is-scroll-up');
		}, 400);
	});

	// 滑動監測 Scroll Active
	// Ref: https://stackoverflow.com/a/9980042/11240898
	function scrollTriggerBuild() {
		// Cache selectors
		var topMenu = $('.js-scroll-active');

		var select = topMenu.find('.custom-select__selected');
		var originText = select.text();

		if (!topMenu.length) { return false }

		var topMenuHeight = $('#header').innerHeight() + topMenu.outerHeight() + 15,
			menuItems = topMenu.find('a'),
			classActive = 'is-active',
			activeSection = '', // Active Cache
			scrollItems = menuItems.map(function(){
				var item = $($(this).attr('href'));
				if (item.length) { return item; }
			});


		var scrollHandler = function() {
			var $this = this ? $(this) : $(window);

			// Get container scroll position
			var fromTop = $this.scrollTop() + topMenuHeight + 100;

			// Get id of current scroll item
			var cur = scrollItems.map(function(){
				if ($(this).offset().top < fromTop)
				return this;
			});

			// Get the id of the current element
			cur = cur[cur.length - 1];
			var id = cur && cur.length ? cur[0].id : '';

			if (activeSection !== id) {
				activeSection = id;
				
				// Set/remove active class
				menuItems.removeClass(classActive).end();

				var current = menuItems.filter("[href='#"+id+"']");
				current.addClass('is-active');
				
				if (current.text() === '') {
					select.text(originText); // 更改文字
				} else {
					select.text(current.text()); // 更改文字
				}
			}
		}

		var scrollHandlerThrottle = throttle(scrollHandler, 50, 200);

		scrollHandler();
		$(window).on('scroll', scrollHandlerThrottle);
	}

	$(window).on('load', function() {
		scrollTriggerBuild();
	});

	// ----------------------------------------------

	// https://www.cnblogs.com/coco1s/p/5499469.html
	// 簡單的節流函數
	function throttle(func, wait, mustRun) {
		var timeout,
			startTime = new Date();
	
		return function() {
			var context = this,
				args = arguments,
				curTime = new Date();
	
			clearTimeout(timeout);
			// 如果達到了規定的觸發時間間隔，觸發 handler
			if(curTime - startTime >= mustRun){
				func.apply(context,args);
				startTime = curTime;
			// 沒達到觸發間隔，重新設定定時器
			}else{
				timeout = setTimeout(func, wait);
			}
		};
	};

	/* ----------------------------------- [END] Trigger Nav */
})(window, document);
